import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AllVideosDataService } from 'src/app/core/service/AllVideosDataService';
import { MatAutocompleteTrigger } from '@angular/material';

@Component({
  selector: 'app-toolbar-search',
  templateUrl: './toolbar-search.component.html',
  styleUrls: ['./toolbar-search.component.scss']
})
export class ToolbarSearchComponent implements OnInit {

  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  
  myControl = new FormControl();
  options: string[] = ['Catatonia', 'Personality Disorders', 'Eating Disorders'];
  listOfAllVideos : any = [];
  filteredVideos : any = [];
  searchedText : string = "";
  constructor(private router: Router,private allvideos : AllVideosDataService) { }



  ngOnInit() {

    if(localStorage.getItem("all_videos")!=null){
      this.listOfAllVideos = JSON.parse(localStorage.getItem("all_videos"));
    }
    //console.log("OnINit");
    this.suscribeVideoListFromDB();
  }

  suscribeVideoListFromDB(){
    this.allvideos.allVideoListFromDB.subscribe(message => {
      //console.log("After Updated"+message);
      if(message.length!=0){
        if(localStorage.getItem("all_videos")!=null){
          this.listOfAllVideos = JSON.parse(localStorage.getItem("all_videos"));
        }
        //console.log("After Updated"+this.listOfAllVideos[0]);
      }
      
    });
  }

  onSearchChange(searchValue : string ) {  
    //console.log(searchValue);
    //filter array based on search value -- Good Case
    this.searchedText = searchValue;
    this.filteredVideos = this.listOfAllVideos.filter(function(videoItem){
      return videoItem.title.toLowerCase().includes(searchValue.toLowerCase());
    });
    //If item is not found exactly -- search in all events  --need to see
  }


  setUpFilterOptions(){

  }

  onSearchItemSelected(optionsItem){
    //alert(JSON.stringify(optionsItem));
    this.router.navigate(['video/'+optionsItem._id.$oid]);
    //this.router.navigate(['search']);
  }

  hideAutoSearch(){
   
    if(this.autocomplete.panelOpen){
      this.autocomplete.closePanel(); 
    }
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      if(this.searchedText.length !=0){
        this.hideAutoSearch();
        this.allvideos.updateSearchedVideosList(this.filteredVideos);
        this.router.navigate(['search']);
      }else{
       // console.log("Text is Zero");
      }
      
    }else{
     
    }

  }

  onSearchIconClicked(){
    if(this.searchedText.length !=0){
      this.hideAutoSearch();
      this.allvideos.updateSearchedVideosList(this.filteredVideos);
      this.router.navigate(['search']);
    }else{
     // console.log("Text is Zero");
    }
  }


}
